import React, { useState } from "react"

export type CheckBoxMultiSelectProps = {
  options: { [value: string]: string }
  initialSelections: string[]
  onChange: (values: string[]) => void
  selectAllText: string
}

export function CheckBoxMultiSelect(props: CheckBoxMultiSelectProps) {
  const { options, initialSelections, onChange, selectAllText } = props
  const [selections, setSelections] = useState(new Set<string>(initialSelections))

  return (
    <div className="flex flex-col gap-1 bg-white p-4 shadow mt-2 text-gray-900">
      <label className="flex gap-2 items-center">
        <input
          type="checkbox"
          checked={selections.size == 0}
          onChange={() => {
            setSelections(new Set())
            onChange(Object.keys(options))
          }}
        />
        {selectAllText}
      </label>
      {Object.entries(options).map(([value, name], i) => (
        <label key={i} className="flex gap-2 items-center">
          <input
            type="checkbox"
            value={value}
            checked={selections.has(value)}
            onChange={(event) => {
              const newSet = new Set(selections)
              if (event.target.checked) {
                newSet.add(value)
              } else {
                newSet.delete(value)
              }
              setSelections(newSet)
              onChange([...newSet])
            }}
          />
          {name}
        </label>
      ))}
    </div>
  )
}
